import { forwardRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../../Typography/Typography.js';
import { getCheckboxLabelStyles, getCheckboxInputStyles, getCheckmarkStyles, getCheckboxIconStyles, getCheckboxTextStyles } from './CheckboxStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { IconSize } from '../../Icon/types/size.js';
import { Icon } from '../../Icon/Icon.js';

let CheckboxSize = /*#__PURE__*/function (CheckboxSize) {
  CheckboxSize["SMALL"] = "small";
  CheckboxSize["MEDIUM"] = "medium";
  CheckboxSize["LARGE"] = "large";
  return CheckboxSize;
}({});
const Checkbox = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    disabled,
    isInvalid,
    indeterminate,
    label,
    tabIndex = 0,
    checked,
    className,
    size = CheckboxSize.MEDIUM,
    ...rest
  } = props;
  const measuresByCheckboxSize = {
    [CheckboxSize.LARGE]: {
      typography: 'body1',
      iconSize: IconSize.SIZE_REGULAR,
      checkmarkSize: 3
    },
    [CheckboxSize.MEDIUM]: {
      typography: 'body2',
      iconSize: IconSize.SIZE_MEDIUM,
      checkmarkSize: 2.5
    },
    [CheckboxSize.SMALL]: {
      typography: 'body2',
      iconSize: IconSize.SIZE_SMALL,
      checkmarkSize: 2
    }
  };
  return jsxs("label", {
    css: getCheckboxLabelStyles(checked, disabled, isInvalid),
    ref: ref,
    className: className,
    children: [jsx("input", {
      type: "checkbox",
      tabIndex: tabIndex,
      checked: checked,
      disabled: disabled,
      css: getCheckboxInputStyles,
      ...rest
    }), jsx("span", {
      css: getCheckmarkStyles(checked, disabled, isInvalid, measuresByCheckboxSize[size].checkmarkSize),
      children: jsx(Icon, {
        name: indeterminate ? IconNames.DASH : IconNames.CHECK_MARK,
        size: measuresByCheckboxSize[size].iconSize,
        css: getCheckboxIconStyles(checked, disabled, measuresByCheckboxSize[size].checkmarkSize)
      })
    }), label && jsx(Typography, {
      variant: measuresByCheckboxSize[size].typography,
      component: "span",
      css: getCheckboxTextStyles,
      children: label
    })]
  });
});
Checkbox.displayName = 'Checkbox';

export { Checkbox, CheckboxSize };
//# sourceMappingURL=Checkbox.js.map
